
import { EventEmitter } from 'events';
import GHObjectType from './GHObjectType';

export default class GHObject extends EventEmitter {
  constructor (typeName, instanceGuid, nickName) {
    super();

    this.objectType = GHObjectType.getObjectType(typeName);
    this.typeName = typeName;
    this.instanceGuid = instanceGuid;
    this.nickName = nickName;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHObject.js